export const DELETE_CART_TYPE = "DELETE_CART_TYPE";
export const GET_CART_TYPE = "GET_CART_TYPE";
export const ADD_CART_TYPE = "ADD_CART_TYPE";
export const UPDATE_CART_TYPE = "UPDATE_CART_TYPE";
export const ADD_SAVE_LATER = "ADD_SAVE_LATER";
export const GET_SAVE_LATER = "GET_SAVE_LATER";
export const DELETE_SAVE_LATER = "DELETE_SAVE_LATER";